module.exports = __webpack_public_path__ + "img/4.92664ba0.png";